import React from 'react';
import { Page } from '../Page';
export function PageOutro2() {
  return <Page hideFooter variant="dark" data-id="element-1545" data-mp="36wpc0uzlyriy">
      <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-1546" data-mp="36vno3pxhuajt">
        {/* Photo - separate from card, narrower */}
        <div className="w-[525px] h-[300px] mb-4 overflow-hidden" data-id="element-1547" data-mp="3bpigdhr5zxui">
          <img src="https://cdn.magicpatterns.com/uploads/7FbupA4igV3MjRPDFBJYCQ/5.png" alt="Jack Achenbach" className="w-full h-full object-cover object-[50%_20%]" data-id="element-1548" data-mp="3fny1fg3oqw5a" />
        </div>

        {/* Card */}
        <div className="bg-[#F5F5F0] w-[620px] px-14 py-10 flex flex-col items-center text-center" data-id="element-1549" data-mp="2nzo1kunabz7m">
          {/* Title */}
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-snug mb-8" data-id="element-1550" data-mp="2wz1576oq9tkf">
            Afterword
          </h1>

          {/* Body Text */}
          <div className="space-y-4 text-[11px] text-[#3B3B3B] leading-[1.8] max-w-[440px]" data-id="element-1551" data-mp="78xs23c86c6w">
            <p data-id="element-1552" data-mp="c6pjyxcvdyb3">If you've made it this far, you already have what you need.</p>
            <p data-id="element-1553" data-mp="1qyj1clec5p7u">
              For many people, seeing the scale finally move is exciting. A lot
              of people have tried for years with diet and exercise alone, so
              seeing progress happen with the help of medication feels like a
              turning point. But this is also where people start to drift.
            </p>
            <p data-id="element-1554" data-mp="1c4e8c8ftgmyv">
              The medication helps you eat less, but that's not the full
              picture. The essentials, what you eat, how you move, and the
              habits you build alongside your medication, are what determine not
              just how much weight you lose, but how you feel, how you look, and
              whether you keep the results long term.
            </p>
            <p data-id="element-1555" data-mp="t9pfgk5ca302">
              The medication is a tool to get you to a new starting point. The
              structure is what determines where you go from there. Keep it
              simple. Come back to the essentials. Stay consistent with what
              works.
            </p>
            <p data-id="element-1556" data-mp="9op4y492399v">
              And most importantly, remember your why. Whether it's your health,
              your family, or your future, that's what carries this forward long
              after the medication ends.
            </p>
          </div>

          {/* Closing Sign-off */}
          <div className="mt-8" data-id="element-1557" data-mp="5p82ljoxes8x">
            <p className="font-serif italic text-lg text-[#1F1F1F]" data-id="element-1558" data-mp="5q9lubg3il1q">
              Jack Achenbach
            </p>
            <p className="text-[9px] text-[#7A7A70] uppercase tracking-[0.2em] mt-1" data-id="element-1559" data-mp="xfl27gwa6woi">
              MS, RDN, CPT
            </p>
          </div>
        </div>
      </div>
    </Page>;
}